import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import { getMusicVolume, getSfxVolume, playUiSound, setMusicVolume, setSfxVolume } from "src/utils/audio"

import "./AudioSettings.css"

/* Two sliders, the same two the geomites app has: the bed and the effects, separately, because
   somebody playing with the radio on wants one of them and not the other.
 *
 * `0-100` is what the player sees and what is stored; `utils/audio` squares it on the way to the
 * output. Both setters apply live — the music bus takes the new level while the pop-up is open,
 * which is the only way to judge a volume — and persist as they go, since there is no form here to
 * submit. */
const AudioSettings = () => {
  const { t } = useTranslation()
  const [music, setMusic] = useState(getMusicVolume)
  const [sfx, setSfx] = useState(getSfxVolume)

  const onMusic = (value) => {
    setMusic(value)
    setMusicVolume(value)
  }

  /* An effects slider with nothing to hear is a slider set blind, so a drag previews itself — but
     throttled to a few a second rather than one per pixel, which is a rattle rather than a level. */
  const lastPreview = useRef(0)
  const onSfx = (value) => {
    setSfx(value)
    setSfxVolume(value)
    const now = Date.now()
    if (now - lastPreview.current > 120) {
      lastPreview.current = now
      playUiSound("click")
    }
  }

  return (
    <div className="audio-settings">
      <span className="section-label">{t("settings.audio")}</span>

      <label className="audio-row" htmlFor="audio-music">
        <span className="audio-name">{t("settings.music")}</span>
        <input
          id="audio-music"
          type="range"
          min="0"
          max="100"
          step="1"
          value={music}
          onChange={(e) => onMusic(Number(e.target.value))}
          style={{ "--fill": `${music}%` }}
        />
        <span className="audio-value">{music}</span>
      </label>

      <label className="audio-row" htmlFor="audio-sfx">
        <span className="audio-name">{t("settings.soundEffects")}</span>
        <input
          id="audio-sfx"
          type="range"
          min="0"
          max="100"
          step="1"
          value={sfx}
          onChange={(e) => onSfx(Number(e.target.value))}
          style={{ "--fill": `${sfx}%` }}
        />
        <span className="audio-value">{sfx}</span>
      </label>
    </div>
  )
}

export default AudioSettings
